<template>
  <div class="tree-form-wrap">
    <el-button plain
      style="width:100%"
      icon="el-icon-plus"
      @click="addLevelOne">新建一级</el-button>
    <el-tree v-loading="loading"
      ref="tree"
      :props="props"
      :data="data"
      :node-key="nodeKey"
      default-expand-all
      highlight-current
      :expand-on-click-node="false">
      <span class="custom-tree-node"
        slot-scope="{ node, data }">
        <a v-if="taskMap.look && lookScope === 'all'"
          href="javascript:;"
          @click="() => look(node, data)">{{ node.label }} <span v-if="showKey">({{node.key}})</span> </a>
        <a v-else-if="taskMap.look && lookScope === 'last' && node.level === maxLevel"
          href="javascript:;"
          @click="() => look(node, data)">{{ node.label }}<span v-if="showKey">({{node.key}})</span></a>
        <span v-else>{{ node.label }}<span v-if="showKey">({{node.key}})</span></span>
        <span class="acton-icon">
          <i class="el-icon-plus"
            v-if="taskMap.append && node.level < maxLevel"
            @click="() => append(node, data)"></i>
          <i class="el-icon-edit"
            v-if="taskMap.edit"
            @click="() => edit(node, data)"></i>
          <i class="el-icon-delete"
            v-if="taskMap.remove"
            @click="() => remove(node, data)"></i>
        </span>
      </span>
    </el-tree>
  </div>
</template>

<script>
export default {
  name: 'TreeForm',
  components: {},
  props: {
    lookScope: String, // all,last
    nodeKey: String,
    task: {
      type: Array,
      require: false,
      default () {
        return []
      }
    },
    maxLevel: {
      type: Number,
      default: 2
    },
    showKey: {
      type: Boolean,
      default: false
    },
    fetchData: {
      type: Function,
      require: true
    },
    props: {
      type: Object,
      required: false,
      default: () => ({
        label: 'label',
        children: 'children'
      })
    }
  },
  data () {
    return {
      data: [],
      loading: false
    }
  },
  watch: {},
  computed: {
    taskMap () {
      return {
        append: this.task.indexOf('append') > -1,
        remove: this.task.indexOf('remove') > -1,
        edit: this.task.indexOf('edit') > -1,
        look: this.task.indexOf('look') > -1
      }
    }
  },
  methods: {
    addLevelOne () {
      this.$emit('node:append', {
        data: {
          parentId: null,
          parentLabel: null
        },
        callback: (newChild) => {
          this.fetch()
        },
        cancel: () => { }
      })
    },
    append (node, data) {
      this.$emit('node:append', {
        data: {
          parentId: data[this.nodeKey],
          parentLabel: data[this.props.label]
        },
        callback: (newChild) => {
          this.fetch()
        },
        cancel: () => { }
      })
    },
    edit (node, data) {
      this.$emit('node:edit', {
        data: {
          [this.nodeKey]: data[this.nodeKey],
          [this.props.label]: data[this.props.label],
          parentId: node.parent.key,
          parentLabel: node.parent.label
        },
        callback: (newChild) => {
          this.fetch()
        },
        cancel: () => { }
      })
    },
    remove (node, data) {
      this.$emit('node:remove', {
        data: {
          [this.nodeKey]: data[this.nodeKey],
          [this.props.label]: data[this.props.label],
          parentId: node.parent.key,
          parentLabel: node.parent.label
        },
        callback: (newChild) => {
          this.fetch()
        },
        cancel: () => { }
      })
    },
    look (node, data) {
      this.$emit('node:look', {
        data: {
          [this.nodeKey]: data[this.nodeKey],
          [this.props.label]: data[this.props.label],
          parentId: node.parent.key,
          parentLabel: node.parent.label
        },
        callback: () => { },
        cancel: () => { }
      })
    },
    fetch () {
      this.loading = true
      this.fetchData({
        callback: (data) => {
          this.loading = false
          this.data = data
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getTreeRefs () {
      return this.$refs.tree
    }
  },
  created () { },
  mounted () {
    this.fetch()
  }
}
</script>
<style lang="stylus" scoped>
.tree-form-wrap {
  padding: 15px;
  max-height: calc(100vh - 140px);
  overflow-y auto
  .custom-tree-node {
    width: 0
    position relative
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 0px;

    &:hover {
      i {
        display: inline-block;
      }
    }
    .acton-icon {
      position: absolute;
      right: 0
      top 0
      background-color: #fff;
      padding: 0 4px
    }
    a {
      color: #409EFF;
      text-decoration: none;
      white-space nowrap
      overflow: hidden
      text-overflow: ellipsis
    }

    i {
      display: none;
    }

    i + i {
      margin-left: 5px;
    }
  }
}
</style>
